import * as React from 'react';
import './_Select.scss';
import { SelectProps } from '../types';
import { HSErrorMessage, isFieldValid } from '../floating/FloatingInput';

export function SelectInput(props: SelectProps) {
    const modifier = props.modifier ?? 'default';
    // Selects are also rendered outside a Formik field, where there is no
    // error state to read.
    const isFormikField = !!props.form && !!props.field;
    const fieldIsValid = isFormikField ? isFieldValid(props.form.errors, props.field.name) : true;

    return (
        <div className={`select select--${modifier}`}>
            <div className={`select__wrap select__wrap--${modifier}`}>
                <select
                    value={''}
                    {...props.field}
                    {...props}
                    className={`select__select select__select--${modifier}${
                        fieldIsValid ? '' : ' select__select--error'
                    }`}
                >
                    {props.options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {' '}
                            {opt.label}{' '}
                        </option>
                    ))}
                </select>
            </div>
            {/* Without this, a required select that fails validation disables the
                submit button while looking perfectly fine on screen. */}
            {isFormikField && (
                <HSErrorMessage
                    showErrorMessageAfterTouch={props.showErrorMessageAfterTouch}
                    touched={props.form.touched}
                    errors={props.form.errors}
                    fieldName={props.field.name}
                />
            )}
        </div>
    );
}
